import { Group } from '@mantine/core';
import Image from 'next/image';

const emojiMap = {
  ':spicy:': { src: '/emoji/spicy.svg', title: 'تند' },
  ':new:': { src: '/emoji/new.svg', title: 'جدید' },
  ':herbal:': { src: '/emoji/herbal.svg', title: 'گیاهی' },
  ':lowfat:': { src: '/emoji/lowfat.svg', title: 'کم چرب' },
  ':diet:': { src: '/emoji/diet.svg', title: 'رژیمی' },
  ':specialoffer:': { src: '/emoji/specialoffer.svg', title: 'خاص' },
  ':vinegar:': { src: '/emoji/vinegar.svg', title: 'سرکه' },
};

export declare type EmojiName = keyof typeof emojiMap;

type Props = {
  name: EmojiName;
  withName?: boolean;
};

export default function Emoji({ name, withName }: Props) {
  const SvgIcon = emojiMap[name]?.src;
  const label = emojiMap[name]?.title;
  return (
    <Group>
      {withName && label} {SvgIcon ? <Image src={SvgIcon} alt={name} width={24} height={24} /> : null}
    </Group>
  );
}
